const PDF_MIME = 'application/pdf';
const DEFAULT_FILE_NAME = 'documento.pdf';

export function crearUrlPdf(base64Data: string): string | null {
  const blob = toPdfBlob(base64Data);
  if (!blob) {
    return null;
  }
  return window.URL.createObjectURL(blob);
}

export function nombrePdf(nombre?: string): string {
  const raw = (nombre || DEFAULT_FILE_NAME).trim() || DEFAULT_FILE_NAME;
  return /\.pdf$/i.test(raw) ? raw : `${raw}.pdf`;
}

/** Dispara la descarga en el gesto actual (tap del botón del modal). */
export function descargarDesdeUrl(url: string, nombre?: string): void {
  if (!url) {
    return;
  }
  const link = document.createElement('a');
  link.href = url;
  link.download = nombrePdf(nombre);
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function revocarUrlPdf(url: string | null | undefined): void {
  if (!url) {
    return;
  }
  window.URL.revokeObjectURL(url);
}

export function descargaPdf(base64Data: string, nombre?: string): void {
  const url = crearUrlPdf(base64Data);
  if (!url) {
    return;
  }
  descargarDesdeUrl(url, nombre);
  window.setTimeout(() => revocarUrlPdf(url), 10000);
}

export const abrirPdf = descargaPdf;

function toPdfBlob(base64Data: string): Blob | null {
  if (!base64Data) {
    return null;
  }
  try {
    const payload = base64Data.indexOf(',') >= 0 ? base64Data.split(',')[1] : base64Data;
    if (!payload) {
      return null;
    }
    const byteCharacters = atob(payload);
    const byteArray = new Uint8Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteArray[i] = byteCharacters.charCodeAt(i);
    }
    return new Blob([byteArray], { type: PDF_MIME });
  } catch {
    return null;
  }
}
